import { PiButton } from '@sensei/pi-component';
import React from 'react';
import useNavigationButtonStyles from '../../styles/navigation-button/navigation-button.style';

type NavigationButtonProps = {
    href: string;
    label: string;
    disabled?: boolean;
};

export default function NavigationButton(props: NavigationButtonProps) {
    const classes = useNavigationButtonStyles();
    const button = (
        <PiButton type="button" color="secondary" disabled={props.disabled}>
            {props.label}
        </PiButton>
    );
    return props.disabled ? (
        button
    ) : (
        <a
            href={props.href}
            className={classes.link}
            target="_blank"
            rel="noreferrer"
        >
            {button}
        </a>
    );
}
